document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('newsletter-form');
  const emailInput = document.getElementById('newsletter-email');
  const messageDiv = document.getElementById('newsletter-message');
  const buttonText = document.querySelector('.newsletter-button-text');
  const loadingSpinner = document.querySelector('.newsletter-loading');

  if (!form) return;

  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    // Reset message
    messageDiv.className = 'text-sm hidden';
    messageDiv.textContent = '';

    // Validate email
    const email = emailInput.value.trim();
    if (!email || !isValidEmail(email)) {
      showMessage('Please enter a valid email address', 'error');
      return;
    }

    // Show loading state
    buttonText.classList.add('hidden');
    loadingSpinner.classList.remove('hidden');

    try {
      const formData = new FormData(form);
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        showMessage('Thank you for subscribing!', 'success');
        form.reset();
      } else {
        const data = await response.json();
        showMessage(data.errors?.email || 'Something went wrong. Please try again.', 'error');
      }
    } catch (error) {
      showMessage('Something went wrong. Please try again.', 'error');
    } finally {
      // Reset button state
      buttonText.classList.remove('hidden');
      loadingSpinner.classList.add('hidden');
    }
  });

  function showMessage(message, type) {
    messageDiv.textContent = message;
    messageDiv.classList.remove('hidden');
    
    if (type === 'error') {
      messageDiv.classList.add('text-red-600');
      messageDiv.classList.remove('text-green-600');
    } else {
      messageDiv.classList.add('text-green-600');
      messageDiv.classList.remove('text-red-600');
    }
  }

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}); 